export function trackGoogleConversion(): Promise<void> {
  return new Promise((resolve) => {
    if (!window.gtag) {
      resolve();
      return;
    }

    window.gtag('event', 'conversion', {
      send_to: 'AW-17732393875/-mTtCMG6tO4bEJO3u4dC',
      value: 1.0,
      currency: 'PLN',
      event_callback: () => resolve(),
    });

    setTimeout(resolve, 2000);
  });
}
